import { ContextMenuItemView, UnitContextMenuClickParams } from '@mark43/cad-api';
import { v4 } from 'uuid';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';
import { useOpenUnitHistoryPanel } from '../unit-history/hooks/use-open-unit-history-panel';
import { usePanelsPermittedInWindow } from '../common/hooks/use-panels-permitted-in-window';
import { useIntegratedActionBroadcaster } from '../action-broadcaster/use-integrated-action-broadcaster';

export function UnitHistoryItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: UnitContextMenuClickParams;
}): React.ReactElement {
    const openUnitHistoryPanel = useOpenUnitHistoryPanel();
    const panelsPermittedInWindow = usePanelsPermittedInWindow();
    const { trigger } = useIntegratedActionBroadcaster();

    return (
        <ContextMenuItem
            dataPendoId="menu-item-unit-history"
            contextMenuItemView={contextMenuItemView}
            onSelect={() => {
                if (!panelsPermittedInWindow) {
                    trigger([
                        {
                            id: v4(),
                            targetWindowType: 'ROOT',
                            type: 'OPEN_EVENT_V2_WINDOW',
                        },
                        {
                            id: v4(),
                            targetWindowType: 'EVENT_V2',
                            type: 'OPEN_UNIT_HISTORY_PANEL_IN_EVENT_WINDOW',
                            payload: {
                                label: clickParams.callSign,
                                value: clickParams.unitId,
                            },
                        },
                    ]);
                } else {
                    // set timeout so context menu container panel doesn't steal back focus from the unit history panel
                    setTimeout(() => {
                        openUnitHistoryPanel({
                            label: clickParams.callSign,
                            value: clickParams.unitId,
                        });
                    }, 0);
                }
            }}
        />
    );
}
